/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


export default
{
  Overview:            '/',

  BuildingAttack:      '/building.attack',
  BuildingCreateList:  '/building.create',
  BuildingCreateType:  '/building.create/:type',
  BuildingUpgrade:     '/building.upgrade',

  UnitAttack:         '/unit.attack',
  UnitCreateList:     '/unit.create',
  UnitCreateType:     '/unit.create/:type',

  ProjectileList:      '/projectile.list',

  WelcomeLogin:        '/login',
  WelcomeAbout:        '/about',
  WelcomeManual:       '/manual/:index',

  WelcomeTerms:        '/terms',
  WelcomePrivacy:      '/privacy',
};
